import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel"]

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.onKeydown)

    this.onResize = this.onResize.bind(this)
    window.addEventListener("resize", this.onResize)

    this.heightObserver = new ResizeObserver(() => this.publishHeight())
    this.heightObserver.observe(this.element)
    this.publishHeight()
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    window.removeEventListener("resize", this.onResize)
    this.heightObserver.disconnect()
  }

  publishHeight() {
    document.documentElement.style.setProperty("--nav-h", `${this.element.offsetHeight}px`)
  }

  toggle() {
    this.setOpen(!this.element.classList.contains("is-open"))
  }

  close() {
    this.setOpen(false)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.setOpen(false)
  }

  onResize() {
    if (window.innerWidth > 760) this.setOpen(false)
  }

  setOpen(open) {
    this.element.classList.toggle("is-open", open)
    this.toggleTarget.setAttribute("aria-expanded", String(open))
    this.toggleTarget.setAttribute("aria-label", open ? "Close menu" : "Open menu")
    document.body.classList.toggle("nav-locked", open)
  }
}
